import DOMPurify from "dompurify";
import { TestimonialButtons } from "@/components/molecules/TestimonialButtons";
import { TestimonialNavigator } from "@/components/molecules/TestimonialNavigator";
import type { TTestimonialCard } from "./types";

export const TestimonialCard = ({
  sliderId,
  indexCard,
  lastIndexArray,
  testimonial,
  author,
  company,
  image,
}: TTestimonialCard) => {
  const initialCardId = "testimonial-card";

  const TestimonialCardElement = document.createElement("div");
  TestimonialCardElement.className =
    "min-w-full w-full flex flex-col bg-white border border-gray-100 md:flex-row";
  TestimonialCardElement.id = `${initialCardId}-${indexCard}`;

  TestimonialCardElement.innerHTML = DOMPurify.sanitize(/* html */ `
        <div class="p-6 flex flex-col gap-6 lg:flex-1 xl:pb-12.5">
            <p class=" text-lg text-blue-600 lg:text-2xl">
                ${testimonial}
            </p>

            <div class="flex flex-col gap-2">
                <h4 class="text-2xl font-medium  text-blue-800 lg:text-3xl">${author}</h4>
                <p class="text-lg  text-gray-600 lg:text-2xl">${company}</p>
            </div>
        </div>

        <div class="flex flex-col md:w-80">
            <img src=${image.src} alt=${image.alt} class="w-full h-100 object-cover md:flex-1" />

            <div class="flex items-center justify-between" id="buttons-container"></div>
        </div>
    `);

  const buttonsContainer =
    TestimonialCardElement.querySelector("#buttons-container");

  if (buttonsContainer) {
    const moveToSlide = (newCardId: number) => {
      const slideElement = document.getElementById(sliderId);
      const newCard = document.getElementById(`${initialCardId}-${newCardId}`);

      if (slideElement && newCard)
        slideElement.scrollTo({
          left: newCard.offsetLeft,
          behavior: "smooth",
        });
    };

    buttonsContainer.appendChild(
      TestimonialButtons({
        leftButton: {
          disabled: indexCard === 0,
          onClick: () => moveToSlide(indexCard - 1),
        },
        rightButton: {
          disabled: indexCard === lastIndexArray,
          onClick: () => moveToSlide(indexCard + 1),
        },
      }),
    );

    buttonsContainer.appendChild(
      TestimonialNavigator({
        currentCardIndex: indexCard,
        lastIndexArray,
        onClickButton: moveToSlide,
      }),
    );
  }

  return TestimonialCardElement;
};
